import { render, staticRenderFns } from "./historicoMargem.vue?vue&type=template&id=c1980640&scoped=true&"
import script from "./historicoMargem.vue?vue&type=script&lang=js&"
export * from "./historicoMargem.vue?vue&type=script&lang=js&"
import style0 from "./historicoMargem.vue?vue&type=style&index=0&id=c1980640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1980640",
  null
  
)

export default component.exports